import { VFC } from "react";

export const UnknownMessage: VFC = () => null; // use null not <></>;
